import { createFileRoute } from "@tanstack/react-router";
import { getSocialEmotionalEditPage } from "#/modules/sociaal-emotioneel/social-emotional.functions";
import { SociaalEmotioneelThemasReeksCrudPage } from "#/modules/sociaal-emotioneel/components/page.crud-sociaal-emotioneel";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/social-emotional/$id/edit/",
)({
  loader: ({ params }) => getSocialEmotionalEditPage({ data: { id: params.id } }),
  component: SchoolSocialEmotionalEditPage,
});

function SchoolSocialEmotionalEditPage() {
  const loaderData = Route.useLoaderData();
  return (
    <SociaalEmotioneelThemasReeksCrudPage
      sociaalEmotioneelThemasReeks={loaderData.sociaalEmotioneelThemasReeks}
      isEditRoute={loaderData.isEditRoute}
      basePath="../social-emotional"
    />
  );
}
